import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Geolocation } from '@ionic-native/geolocation/ngx';

@Injectable({
  providedIn: 'root'
})
export class GeolocationService {
  departamento: any;
  municipio: any;
  direccion: any;

  constructor(private geo:Geolocation,private http:HttpClient) { }

  /**
   * It returns a promise that resolves to the current position of the user
   * @returns A promise
   */
  initGeolocation(){
    return this.geo.getCurrentPosition()
  }
 

}
